import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { StripedDataGrid } from '../../../styledComponents/datagrid';
import { renderCellExpand } from '../../../components/library/DataGrid/renderCellExpand';
import { InventoryAdjustmentItem } from '../../../services/inventory/types';

interface InventoryAdjustmentItemDetailsProps {
  items: InventoryAdjustmentItem[];
}

const columns: GridColDef[] = [
  {
    headerName: 'SKU',
    field: 'sku',
    renderCell: renderCellExpand,
    flex: 2,
  },
  {
    headerName: 'Quantity Adjusted',
    field: 'quantityAdjusted',
    flex: 2,
    renderCell: params => (
      <Chip
        label={`${params.value > 0 ? '+' : ''}${params.value}`}
        color={params.value > 0 ? 'success' : 'error'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    headerName: 'Warehouse Bin',
    field: 'warehouseBin',
    flex: 2,
    renderCell: params => <Typography variant="body2">{params.value?.code || 'N/A'}</Typography>,
  },
  {
    headerName: 'Amount',
    field: 'amount',
    flex: 2,
    renderCell: params => {
      if (params.value !== null && params.value !== undefined) {
        return <Typography variant="body2">${parseFloat(params.value).toFixed(2)}</Typography>;
      }
      return <Typography variant="body2">N/A</Typography>;
    },
  },
  {
    headerName: 'Created',
    field: 'created',
    flex: 3,
    renderCell: renderCellExpand,
    valueGetter: ({ value }: { value: string }) =>
      new Date(value).toLocaleString('en-US', { timeZone: 'America/Denver' }),
  },
];

const InventoryAdjustmentItemDetails: React.FC<InventoryAdjustmentItemDetailsProps> = ({
  items,
}) => {
  if (!items || items.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No items found for this adjustment.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Adjustment Items ({items.length})
      </Typography>
      <StripedDataGrid rows={items} columns={columns} />
    </Box>
  );
};

export default InventoryAdjustmentItemDetails;
